import Joi from 'joi';
import type { IVocalise } from './vocalise';
import { vocaliseSchema } from './vocalise';
import { actionCreator, objectSchemaOf } from '../helpers';

export const HIDE = 'VOCALISE/HIDE';

export interface IHideAction {
  type: typeof HIDE;
  payload: IVocalise;
}

export const hideActionSchema = objectSchemaOf<IHideAction>({
  type: Joi.string().required().valid(HIDE),
  payload: vocaliseSchema.required(),
});

export const hide = actionCreator({
  type: HIDE,
  schema: hideActionSchema,
});
